import { render, staticRenderFns } from "./ShareFormModal.vue?vue&type=template&id=1f514f1f"
import script from "./ShareFormModal.vue?vue&type=script&lang=js"
export * from "./ShareFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports